/**
 * If you want to give permission to any of these 
 * So, you have to add role 
 * Ex: You want to give permission to Employee 
 * Roles will be like ['System Manager', 'Employee'] 
 * [] Roles means no one has permission 
 * 
 */

const RequiredPermission = {
    "DASHBOARD": {
        "READ": ['Billing Manager', 'System Manager', 'Project Manager', 'Medical Coder']
    },
    "RED_ROAD_SERVICE": {
        "CREATE": ['Billing Manager', 'System Manager'],
        "READ": ['Billing Manager', 'System Manager', 'Project Manager'],
        "UPDATE": ['Billing Manager', 'System Manager', 'Project Manager'],
        "DELETE": ['Billing Manager', 'System Manager'],
        "HIDEFIELD":['Project Manager']
    },
    "INVOICE": {
        "CREATE": ['Billing Manager', 'System Manager'],
        "READ": ['Billing Manager', 'System Manager'],
        "UPDATE": ['Billing Manager', 'System Manager'],
        "DELETE": ['Billing Manager', 'System Manager']
    },
    "BILLING_INFORMATION": {
        "CREATE": ['Billing Manager', 'System Manager', 'Project Manager'],
        "READ": ['Billing Manager', 'System Manager', 'Project Manager'],
        "UPDATE": ['Billing Manager', 'System Manager', 'Project Manager'],
        "DELETE": ['Billing Manager', 'System Manager', 'Project Manager'],
        "APPROVEL": ['Billing Manager', 'System Manager']
    },
    "CLIENT": {
        "CREATE": ['Billing Manager', 'System Manager'],
        "READ": ['Billing Manager', 'System Manager', 'Project Manager'],
        "UPDATE": ['Billing Manager', 'System Manager', 'Project Manager'],
        "DELETE": ['Billing Manager', 'System Manager']
    },
    "SETTINGS": {
        "READ": ['Billing Manager', 'System Manager', 'Project Manager']
    },
    "SYSTEM_SETTINGS": {
        "READ": ['Billing Manager', 'System Manager']
    },
    "CLIENT_POC": {
        "CREATE": ['Billing Manager', 'System Manager'],
        "READ": ['Billing Manager', 'System Manager', 'Project Manager'],
        "UPDATE": ['Billing Manager', 'System Manager', 'Project Manager'],
        "DELETE": ['Billing Manager', 'System Manager']
    },
    "COMPANY": {
        "CREATE": ['Billing Manager', 'System Manager'],
        "READ": ['Billing Manager', 'System Manager'],
        "UPDATE": ['Billing Manager', 'System Manager'],
        "DELETE": ['Billing Manager', 'System Manager']
    },
    "NOTE": {
        "CREATE": ['Billing Manager', 'System Manager', 'Project Manager'],
        "READ": ['Billing Manager', 'System Manager', 'Project Manager'],
        "UPDATE": ['Billing Manager', 'System Manager', 'Project Manager'],
        "DELETE": ['Billing Manager', 'System Manager', 'Project Manager']
    },
    "PROCESS": {
        "CREATE": ['Billing Manager', 'System Manager'],
        "READ": ['Billing Manager', 'System Manager', 'Project Manager'],
        "UPDATE": ['Billing Manager', 'System Manager'],
        "DELETE": ['Billing Manager', 'System Manager']
    },
    "VERTICAL": {
        "CREATE": ['Billing Manager', 'System Manager'],
        "READ": ['Billing Manager', 'System Manager', 'Project Manager'],
        "UPDATE": ['Billing Manager', 'System Manager'],
        "DELETE": ['Billing Manager', 'System Manager']
    },
    "DEPARTMENT": {
        "CREATE": ['Billing Manager', 'System Manager'],
        "READ": ['Billing Manager', 'System Manager', 'Project Manager'],
        "UPDATE": ['Billing Manager', 'System Manager'],
        "DELETE": ['Billing Manager', 'System Manager']
    },
    "BILLING_TYPES": {
        "CREATE": ['Billing Manager', 'System Manager'],
        "READ": ['Billing Manager', 'System Manager', 'Project Manager'],
        "UPDATE": ['Billing Manager', 'System Manager'],
        "DELETE": ['Billing Manager', 'System Manager']
    },
    "BILLING_ENTITY": {
        "CREATE": ['Billing Manager', 'System Manager'],
        "READ": ['Billing Manager', 'System Manager', 'Project Manager'],
        "UPDATE": ['Billing Manager', 'System Manager', 'Project Manager'],
        "DELETE": ['Billing Manager', 'System Manager']
    },
    "BILLING_FREQUENCY": {
        "CREATE": ['Billing Manager', 'System Manager'],
        "READ": ['Billing Manager', 'System Manager', 'Project Manager'],
        "UPDATE": ['Billing Manager', 'System Manager'],
        "DELETE": ['Billing Manager', 'System Manager']
    },
    "USER": {
        "CREATE": ['System Manager', 'Billing Manager'],
        "READ": ['System Manager', 'Billing Manager', 'Project Manager'],
        "UPDATE": ['System Manager', 'Billing Manager', 'Project Manager'],
        "DELETE": ['System Manager', 'Billing Manager'],
        "CHECK_ROLE": ['System Manager', 'Billing Manager']
    },
    "BANK_DETAILS": {
        "CREATE": ['System Manager', 'Billing Manager'],
        "READ": ['System Manager', 'Billing Manager'],
        "UPDATE": ['System Manager', 'Billing Manager'],
        "DELETE": ['System Manager', 'Billing Manager'],
        "CHECK_ROLE": ['System Manager', 'Billing Manager']
    }
}


export const GlobleHideAndDisabledFieldAndButtonRole = ['Billing Manager', 'System Manager']


export default RequiredPermission;